import React from 'react';
import { Section } from './ui/Section';
export function Benefits() {
  const benefits = [{
    title: 'Seguridad Clínica',
    before: 'Sin saber cómo estructurar la sesión',
    after: 'Protocolo claro desde el minuto 1'
  }, {
    title: 'Captación',
    before: 'Dependes de que te recomienden',
    after: '5 vías activas de pacientes'
  }, {
    title: 'Legal',
    before: 'Sin contrato ni documentos',
    after: 'Todo firmado y protegido'
  }, {
    title: 'Imagen',
    before: 'Presentación genérica y confusa',
    after: 'Identidad profesional sólida'
  }];
  return <Section variant="alt" data-id="element-15">
      <h2 className="font-display text-2xl md:text-3xl font-bold text-center mb-3 text-brand-primary" data-id="element-16">
        ⚡ LA TRANSFORMACIÓN
      </h2>
      <p className="font-body text-center text-brand-text mb-6 font-semibold" data-id="element-17">
        De psicólogo inseguro a profesional con autoridad clínica
      </p>

      <div className="grid md:grid-cols-2 gap-4 max-w-4xl mx-auto mb-6" data-id="element-18">
        {benefits.map((benefit, i) => <div key={i} className="bg-white border border-brand-border rounded-lg p-4 shadow-sm" data-id="element-19">
            <h3 className="font-heading text-lg font-bold text-brand-primary mb-3" data-id="element-20">
              {benefit.title}
            </h3>

            <div className="space-y-2" data-id="element-21">
              <div className="flex items-start gap-2" data-id="element-22">
                <span className="text-red-500 shrink-0" data-id="element-23">❌</span>
                <p className="font-body text-brand-textMuted text-sm" data-id="element-24">
                  {benefit.before}
                </p>
              </div>

              <div className="flex items-start gap-2" data-id="element-25">
                <span className="text-green-500 shrink-0" data-id="element-26">✅</span>
                <p className="font-body text-brand-primary text-sm font-semibold" data-id="element-27">
                  {benefit.after}
                </p>
              </div>
            </div>
          </div>)}
      </div>

      <div className="bg-white border-2 border-brand-accent rounded-lg p-4 max-w-2xl mx-auto" data-id="element-28">
        <div className="grid grid-cols-3 gap-4 text-center" data-id="element-29">
          <div data-id="element-30">
            <div className="font-heading text-xl font-bold text-brand-accent" data-id="element-31">
              +150h
            </div>
            <div className="font-body text-brand-textMuted text-xs" data-id="element-32">
              ahorradas/año
            </div>
          </div>
          <div data-id="element-33">
            <div className="font-heading text-xl font-bold text-brand-accent" data-id="element-34">
              7 días
            </div>
            <div className="font-body text-brand-textMuted text-xs" data-id="element-35">
              lista tu consulta
            </div>
          </div>
          <div data-id="element-36">
            <div className="font-heading text-xl font-bold text-brand-accent" data-id="element-37">
              100%
            </div>
            <div className="font-body text-brand-textMuted text-xs" data-id="element-38">
              profesional ya
            </div>
          </div>
        </div>
      </div>
    </Section>;
}